import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import ServiceDashboard from "@/pages/ServiceDashboard";

export default function ServiceModulePanel() {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    api.get("/admin/service/guests")
      .then(({ data }) => { if (live) setGuests(Array.isArray(data) ? data : []); })
      .catch((e) => { if (live) toast.error(formatErr(e.response?.data?.detail) || "Could not load onboard guests"); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, []);

  if (loading) return <div className="border border-border bg-card p-8 text-sm text-muted-foreground">Loading onboard guests…</div>;
  return <ServiceDashboard guests={guests} />;
}
